<template>
  <div class="container-fluid" style="padding: 0!important;">
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="formValidator">

      <b-row>
        <b-col sm="9">
          <b-row no-gutters>
            <b-col sm="12" class="text-right">
              <base-input
                v-model="newReward.name"
                label="نام"
                required
                :rules="{ required: true}"
                id="name"
                name="نام"
              ></base-input>
            </b-col>
            <b-col sm="12" class="text-right">
              <base-textarea
                required
                :rules="{ required: true}"
                v-model="newReward.description"
                label="توضیحات"
                :rows="4"
                name="توضیحات"
              ></base-textarea>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="3" class="text-right">
          <label for="">
            انتخاب تصویر
          </label>
          <div class="upload-container">
                     <span
                       @click="removeImage"
                       v-if="newReward.image"
                       class="close-image-btn">
                      پاک کردن
                    </span>
            <input
              ref="file-input"
              accept="image/*"
              type="file"
              class="file-input"
              @change="onSelectImage($event.target)">
            <i v-if="!newReward.image" class="fas fa-plus"></i>
            <img ref="image-preview" src="" class="img" alt="">
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="text-right mb-3">
          <b-form-checkbox
            class="text-right"
            id="campaign"
            v-model.number="newReward.campaign"
            name="campaign"
            value="1"
            unchecked-value="0"
          >
            به عنوان کمپین
          </b-form-checkbox>
        </b-col>

        <b-col sm="6" class="text-right mb-3">
          <b-form-checkbox
            class="text-right"
            id="private"
            :checked="newReward.private"
            @change="(value)=>{newReward.private = value}"
            name="private"
          >
            به کاربر نشان داده نشود؟
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row>

        <b-col sm="12" class="my-2 text-right" v-if="portionUserError">
          <b-alert
            show
            class="p-2"
            variant="warning"
          >{{ portionUserError }}
          </b-alert>
        </b-col>


        <b-col sm="4" class="text-right my-1">
          <label for="portion_for_user">
            درصد برای کاربر
          </label>
          <Slider
            class="mt-2"
            tooltipPosition="bottom"
            direction="rtl"
            v-model.number="newReward.portion_for_user"/>
        </b-col>

        <b-col sm="4" class="text-right my-1">
          <label for="portion_for_referrer">
            درصد برای معرف
          </label>
          <Slider
            class="mt-2"
            tooltipPosition="bottom"
            direction="rtl"
            v-model.number="newReward.portion_for_referrer"/>
        </b-col>

        <b-col sm="4" class="text-right my-1">
          <label for="portion_for_2nd_referrer">
            درصد برای معرف دوم
          </label>
          <Slider
            class="mt-2"
            tooltipPosition="bottom"
            direction="rtl"
            v-model.number="newReward.portion_for_2nd_referrer"/>
        </b-col>


      </b-row>

      <b-row class="mt-6">
        <b-col sm="12" class="text-right">
          <label for="static_reward_type">
            جایز ایستا هم ارز
          </label>
          <base-select
            v-model="newReward.static_reward_type"
            id="static_reward_type"
            name="static_reward_type"
            :options="staticRewardTypeOptions"
          >
          </base-select>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col sm="12" class="text-right">
          <label for="action_type">
            مدل جایزه
          </label>
          <base-select
            :rules="{required:true}"
            required
            v-model="newReward.action_type"
            id="action_type"
            name="action_type"
            :options="actionTypeOptions"
          >
          </base-select>
        </b-col>
      </b-row>

      <b-row class="my-3" v-if="isActionTypeEqualFixed">
        <b-col sm="6" class="text-right">
          <label for="fixed_value">
            مقدار مشخص
          </label>
          <base-input
            :rules="{required:true}"
            required
            v-model="newReward.fixed_value"
            id="fixed_value"
            name="fixed_value"
          ></base-input>
        </b-col>
        <b-col sm="6" class="text-right">
          <label for="fixed_token">
            رمزارز مشخص
          </label>
          <base-input
            :rules="{required:true}"
            required
            v-model="newReward.fixed_token"
            id="fixed_token"
            name="fixed_token"
          ></base-input>
        </b-col>
      </b-row>

      <b-row class="my-3" v-else>

        <b-col sm="12">
          <b-row no-gutters>
            <b-col sm="12" class="text-right">
              <label for="fixed_value">
                درصد
              </label>
              <base-input
                :rules="{required:true,}"
                required
                type="number"
                v-model="newReward.percent_value"
                id="percent_value"
                name="percent_value"
              ></base-input>
            </b-col>
            <b-col sm="12" class="text-right mt-3">
              <base-checkbox
                v-model="newReward.percentage_of_commission"
                id="percentage_of_commission"
                name="percentage_of_commission"
              >
                درصد از کمیسیون
              </base-checkbox>
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="12" v-if="isActionTypeEqualPercentageOfTokenBalance" class="text-right mt-3">
          <label for="token">
            رمزارز
          </label>
          <base-input
            :rules="{required:true}"
            required
            v-model="newReward.token"
            id="token"
          />
        </b-col>

        <b-col sm="12" v-if="isActionTypeEqualPercentageOfEach" class="text-right mt-3">
          <label for="token">
            درصد از هر
          </label>
          <base-select
            :rules="{required:true}"
            required
            :options="percentageOfEachOptions"
            v-model="newReward.percentage_of_each"
            id="percentage_of_each"
          />
        </b-col>

        <b-col sm="12" v-if="isActionTypeEqualPercentageOfEachCrypto" class="text-right mt-3">
          <label for="percentage_of_each_crypto">
            درصد از هر رمزارز
          </label>
          <base-select
            :rules="{required:true}"
            required
            :options="percentageOfEachOptions"
            v-model="newReward.percentage_of_each_crypto"
            id="percentage_of_each_crypto"
          />
        </b-col>

      </b-row>

      <b-row>
        <b-col sm="12" class="text-right mt-3">
          <label for="time_type">
            نوع ساختار زمانی
          </label>
          <base-select
            :rules="{required:true}"
            required
            :options="timeTypeOptions"
            v-model="newReward.time_type"
            id="time_type"
          />
        </b-col>

        <b-col sm="12" class="text-right mt-3" v-if="isTimeTypeEqualAt">
          <label for="date_at">
            در تاریخ
          </label>
          <date-picker v-model="newReward.date_at"/>
        </b-col>

        <b-col sm="12" class="text-right mt-3" v-if="isTimeTypeEqualEveryDayFor">
          <label for="d">
            تعداد روز
          </label>
          <base-input
            :rules="{required:true}"
            required
            name="d"
            type="number"
            id="d"
            v-model="newReward.d"
          />
        </b-col>

        <b-col sm="12" class="text-right mt-3" v-if="isTimeTypeEqualEveryDayFromTo">
          <label for="date_from">
            از تاریخ
          </label>
          <date-picker
            name="date_from"
            id="date_from"
            v-model="newReward.date_from"
          />
        </b-col>

        <b-col sm="12" class="text-right mt-3" v-if="isTimeTypeEqualEveryDayFromTo">
          <label for="date_to">
            تا تاریخ
          </label>
          <date-picker
            name="date_to"
            id="date_to"
            v-model="newReward.date_to"
          />
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col>
          <b-overlay
            :show="newReward.loading"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block">
            <b-button
              @click="createNewReward"
              variant="success"
              :disabled="invalid">
              ثبت جایزه
              <b-icon v-if="newReward.loading"
                      icon="circle-fill"
                      animation="throb"
                      font-scale="1"
              ></b-icon>
            </b-button>
          </b-overlay>
        </b-col>
      </b-row>

    </validation-observer>
  </div>
</template>

<script>
import {submitNewReward} from "@/httpservices/Reward";
import moment from "jalali-moment";
import Slider from '@vueform/slider/dist/slider.vue2.js'
import {BaseTextarea, BaseSelect, BaseCheckbox} from "@/components";

const actionTypeValues = {
  FIXED: "FIXED",
  PERCENTAGE_OF_LAST: "PERCENTAGE_OF_LAST",
  PERCENTAGE_OF_HIGHEST: "PERCENTAGE_OF_HIGHEST",
  PERCENTAGE_OF_EACH: "PERCENTAGE_OF_EACH",
  PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS: "PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS",
  PERCENTAGE_OF_TOTAL: "PERCENTAGE_OF_TOTAL",
  PERCENTAGE_OF_TOTAL_BALANCE: "PERCENTAGE_OF_TOTAL_BALANCE",
  PERCENTAGE_OF_TOKEN_BALANCE: "PERCENTAGE_OF_TOKEN_BALANCE",
};
const percentageOfEachValues = {
  ALL: "ALL",
  TRADE: "TRADE",
  TRANSACTION: "TRANSACTION",
  TRANSACTION_CRYPTO: "TRANSACTION_CRYPTO",
  TRANSACTION_CRYPTO_TRADE: "TRANSACTION_CRYPTO_TRADE",
  TRANSACTION_FIAT: "TRANSACTION_FIAT",
  TRANSACTION_CRYPTO_DEPOSIT: "TRANSACTION_CRYPTO_DEPOSIT",
  TRANSACTION_CRYPTO_WITHDRAW: "TRANSACTION_CRYPTO_WITHDRAW",
  TRANSACTION_FIAT_DEPOSIT: "TRANSACTION_FIAT_DEPOSIT",
  TRANSACTION_FIAT_WITHDRAW: "TRANSACTION_FIAT_WITHDRAW",
};
const percentageOfEachCryptoValues = {
  ALL: "ALL",
  TRADE: "TRADE",
  TRANSACTION: "TRANSACTION",
  TRANSACTION_CRYPTO_DEPOSIT: "TRANSACTION_CRYPTO_DEPOSIT",
  TRANSACTION_CRYPTO_WITHDRAW: "TRANSACTION_CRYPTO_WITHDRAW",
};
const timeTypeValues = {
  EVERYDAY_FOR: "EVERYDAY_FOR",
  EVERYDAY_FROM_TO: "EVERYDAY_FROM_TO",
  OVER_ANY_RANGE_OF: "OVER_ANY_RANGE_OF",
  OVER_FROM_TO: "OVER_FROM_TO",
  ANY_DAY_FROM_TO: "ANY_DAY_FROM_TO",
  AT: "AT",
  ANYTIME: "ANYTIME",
};


import "@vueform/slider/themes/default.css"

export default {

  name: "NewReward",

  components: {
    Slider,
    BaseTextarea,
    BaseSelect,
    BaseCheckbox,
  },

  data() {
    return {
      newReward: {
        loading: false,
        name: "",
        description: "",
        image: "",
        image_extension: "",
        image_content: "",
        campaign: false,
        portion_for_user: 0,
        portion_for_referrer: 0,
        portion_for_2nd_referrer: 0,
        action_type: "",
        time_type: "",
        static_reward_type: undefined,
        private: true,
      },
      actionTypeOptions: [
        {
          value: actionTypeValues.FIXED,
          text: 'جایزه ثابت',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_LAST,
          text: 'درصد از اخرین',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_HIGHEST,
          text: 'درصد از بالاترین',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_EACH,
          text: 'درصد از هر',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS,
          text: 'درصد از هر رمزارز',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_TOTAL,
          text: 'درصد از کل',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_TOTAL_BALANCE,
          text: 'درصد از کل موجودی',
        },
        {
          value: actionTypeValues.PERCENTAGE_OF_TOKEN_BALANCE,
          text: 'درصد از موجودی رمزارز',
        },
      ],
      percentageOfEachOptions: [
        {
          value: percentageOfEachValues.ALL,
          text: "همه",
        },
        {
          value: percentageOfEachValues.TRADE,
          text: "ترید",
        },
        {
          value: percentageOfEachValues.TRANSACTION,
          text: "تراکنش",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO,
          text: "تراکنش رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_TRADE,
          text: "تراکنش و ترید رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT,
          text: "تراکنش تومانی",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_DEPOSIT,
          text: "واریز رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_WITHDRAW,
          text: "برداشت رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT_DEPOSIT,
          text: "واریز تومان",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT_WITHDRAW,
          text: "برداشت تومان",
        },
      ],
      percentageOfEachCryptoOptions: [
        {
          value: percentageOfEachCryptoValues.ALL,
          text: "همه"
        },
        {
          value: percentageOfEachCryptoValues.TRADE,
          text: "ترید"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION,
          text: "تراکنش"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION_CRYPTO_DEPOSIT,
          text: "واریز رمزارز"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION_CRYPTO_WITHDRAW,
          text: "برداشت رمزارز"
        },
      ],
      timeTypeOptions: [
        {
          value: timeTypeValues.EVERYDAY_FOR,
          text: "روز متوالی"
        },
        {
          value: timeTypeValues.EVERYDAY_FROM_TO,
          text: "هر روز از"
        },
        {
          value: timeTypeValues.OVER_ANY_RANGE_OF,
          text: "در هر بازه زمانی"
        },
        {
          value: timeTypeValues.OVER_FROM_TO,
          text: "در یک بازه زمانی"
        },
        {
          value: timeTypeValues.ANY_DAY_FROM_TO,
          text: "هر روز در یک بازه زمانی"
        },
        {
          value: timeTypeValues.AT,
          text: "در تاریخ"
        },
        {
          value: timeTypeValues.ANYTIME,
          text: "هر زمانی"
        },
      ],
      value: 20,
      staticRewardTypeOptions: [
        {
          text: "هیج کدام",
          value: undefined
        },
        {
          text: "جایزه انتقال موجودی پرفکت کریپتو",
          value: 0
        },
        {
          text: "جایزه ی ثابت انتقال از پرفکت کریپتو",
          value: 1
        },
        {
          text: " جایزه ی خرید ارز برای کاربران پرفکت کریپتو",
          value: 2
        },
      ]
    }
  },

  methods: {

    onSelectImage(input) {
      const [file] = input.files;
      if (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.newReward.image_content = reader.result.split(',', 2)[1];
        };


        this.newReward.image = file;
        this.$refs['image-preview'].src = URL.createObjectURL(file);
        this.newReward.image_extension = file.name.split('.').pop();
        // this.newReward.image_content = file.name.split('.').pop() + '==';
      }
    },

    removeImage() {
      this.newReward.image = null;
      this.newReward.image_extension = null;
      this.newReward.image_content = null;
      this.$refs['file-input'].value = "";
      this.$refs['image-preview'].src = "";

    },

    convertDateFromJalali(date) {
      return moment(date, 'jYYYY/jMM/jDD HH:mm:ss').utc().locale('en').format('DD/MM/yyyy');
    },

    createNewReward() {
      this.newReward.loading = true;
      submitNewReward({
        ...this.newReward,
        campaign: Boolean(this.newReward.campaign),
        percentage_of_commission: Boolean(this.newReward.percentage_of_commission),
        date_at: this.newReward.date_at && this.convertDateFromJalali(this.newReward.date_at),
        date_from: this.newReward.date_from && this.convertDateFromJalali(this.newReward.date_from),
        date_to: this.newReward.date_to && this.convertDateFromJalali(this.newReward.date_to),
        static_reward_type: this.newReward.static_reward_type === null ? undefined : this.newReward.static_reward_type,
      })
        .then(res => {
          this.newReward.loading = false;
          this.resetForm();
          this.$swal({
            position: "center",
            icon: "success",
            title: "جایزه جدید با موفقیت ثبت شد.",
            showConfirmButton: false,
            timer: 1500
          });
          this.$emit('add-new-reward');
        })
        .catch(e => {
          this.newReward.loading = false;
        })
    },

    resetForm() {
      this.removeImage();
      this.$refs['formValidator'].reset();
      this.newReward = {
        loading: false,
        name: "",
        description: "",
        image: "",
        image_extension: "",
        image_content: "",
        campaign: false,
        portion_for_user: 0,
        portion_for_referrer: 0,
        portion_for_2nd_referrer: 0,
        action_type: "",
        time_type: "",
        static_reward_type: undefined,
        private: true,
      }
    },

  },

  computed: {
    isActionTypeEqualFixed() {
      return Boolean(this.newReward.action_type === actionTypeValues.FIXED);
    },
    isActionTypeEqualPercentageOfTokenBalance() {
      return Boolean(this.newReward.action_type === actionTypeValues.PERCENTAGE_OF_TOKEN_BALANCE);
    },
    isActionTypeEqualPercentageOfEach() {
      return Boolean(this.newReward.action_type === actionTypeValues.PERCENTAGE_OF_EACH);
    },
    isActionTypeEqualPercentageOfEachCrypto() {
      return Boolean(this.newReward.action_type === actionTypeValues.PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS);
    },
    isTimeTypeEqualAt() {
      return Boolean(this.newReward.time_type === timeTypeValues.AT);
    },
    isTimeTypeEqualEveryDayFor() {
      return Boolean(
        (this.newReward.time_type === timeTypeValues.EVERYDAY_FOR)
        || (this.newReward.time_type === timeTypeValues.OVER_ANY_RANGE_OF));
    },
    isTimeTypeEqualEveryDayFromTo() {
      return Boolean(
        (this.newReward.time_type === timeTypeValues.EVERYDAY_FROM_TO)
        || (this.newReward.time_type === timeTypeValues.OVER_FROM_TO)
        || (this.newReward.time_type === timeTypeValues.ANY_DAY_FROM_TO)
      );
    },
    portionUserError() {
      const sum = this.newReward.portion_for_2nd_referrer + this.newReward.portion_for_user + this.newReward.portion_for_referrer;
      if (sum !== 100) {
        return 'جمع مقادیر پایین باید برابر ۱۰۰ باشد.'
      }
    }
  },

}
</script>

<style>

:root {
  --slider-connect-bg: #3B82F6;
  --slider-tooltip-bg: #3B82F6;
  --slider-handle-ring-color: #3B82F630;
}

.slider-txt-dir-rtl.slider-horizontal .slider-handle {
  left: auto !important;
  right: auto;
}
</style>
